import { render, staticRenderFns } from "./ProceedingSubgroup.vue?vue&type=template&id=9ab8a730&scoped=true"
import script from "./ProceedingSubgroup.vue?vue&type=script&lang=js"
export * from "./ProceedingSubgroup.vue?vue&type=script&lang=js"
import style0 from "./ProceedingSubgroup.vue?vue&type=style&index=0&id=9ab8a730&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab8a730",
  null
  
)

export default component.exports